/**
 * Textos (es) de planta — OBR-87: recepció sense comanda prèvia: namespace `planta.receptionDirect`.
 * Tall propi: no es toca `ca.ts`. Les tres llengües han de tenir les mateixes claus (i18n.test.ts) i les mateixes
 * variables. Vocabulari del sector: «Existències», mai «Stock».
 */

export const receptionDirectEs = {
  'planta.receptionDirect': {
    // ── Permiso: quién puede recibir sin pedido (admin, compras, operario: lo que el servidor deja escribir) ──
    noPermission:
      'Solo la administración, compras y los operarios pueden registrar una recepción sin pedido.',

    // ── Proveedor: la única exigencia dura (la lista está en el dispositivo: elegirlo no pide conexión) ──
    supplierRequired: 'Elige el proveedor antes de confirmar la recepción.',
    supplierFirstHint: 'Elige primero el proveedor: solo se ofrecen sus artículos.',
    supplierChange: 'Cambiar',

    // ── Proveedor: duro, pero nunca mudo (qué hacer según el caso), búsqueda y cambio sin perder nada en silencio ──
    suppliersNoneOnDevice:
      'Este dispositivo no tiene ningún proveedor. Conéctate y sincroniza para descargar los proveedores.',
    supplierNotListedHint:
      'Si el proveedor no está, pide a Compras que lo dé de alta en el BackOffice.',
    supplierSearch: 'Buscar un proveedor',
    supplierSearchNoMatch: 'Ningún proveedor coincide con la búsqueda.',
    supplierChangeTitle: '¿Cambiar a {{supplier}}?',
    supplierChangeLoses_one: 'Se perderá {{count}} línea de este albarán.',
    supplierChangeLoses_other: 'Se perderán las {{count}} líneas de este albarán.',
    supplierChangeKeep: 'No cambiar',
    supplierChangeConfirm: 'Cambiar y quitar las líneas',

    // ── Lote del proveedor: exigido, con salida (nunca atrapado) ──
    lotMissing: 'Falta el lote del proveedor de esta entrada.',
    lotMissingSummary_one:
      'Falta el lote del proveedor de {{count}} entrada. Escríbelo o confirma sin lote.',
    lotMissingSummary_other:
      'Falta el lote del proveedor de {{count}} entradas. Escríbelos o confirma sin lote.',
    lotAndExpiryMissingSummary:
      'Faltan el lote del proveedor y la caducidad de alguna entrada. Rellénalos o confirma igualmente.',
    confirmWithoutLot: 'Confirma sin lote del proveedor',
    confirmWithoutLotHint:
      'Si no lo sabes, puedes confirmar igualmente: el género entra con el lote interno, pero sin el lote del proveedor. Quedará anotado en el registro de actividad.',
    confirmWithoutBoth: 'Confirma sin lote ni caducidad',
    confirmWithoutBothHint:
      'Si no lo sabes, puedes confirmar igualmente: el género entra con el lote interno, sin el lote del proveedor ni la caducidad. La existencia queda en «A regularizar» hasta que se le ponga la caducidad. Quedará anotado en el registro de actividad.',

    // ── Selector de artículos: salida cuando el proveedor no tiene vinculados ──
    pickerShowAll: 'Mostrar todos los artículos',
    pickerShowSupplierOnly: 'Solo los artículos de este proveedor',
  },
} as const;
